<div class="article-card pointer" (click)="viewArticle()" *ngIf="Article">
  <img (error)="hasImage = false"
       [alt]="Article?.Title"
       [src]="imageUrl"
       class="article-image d-none">
  <div class="article-headline"
       [ngStyle]="{'background-image': getImageUrl() }">
    <p class="article-headline-text article-image-overlay">
      {{ Article?.Title }}
    </p>
  </div>
  <div class="article-body">
    <div class="row">
      <div class="col-12 text-center">
        <span class="float-start ps-2">
          <p class="article-publish-date">
            {{ Article?.PublishDate | date: env.FormattingStandards.ShortDateFormat }}
          </p>
        </span>
        <span class="float-end pe-2 pt-1">
          <small class="harmony-accent-coral-text fw-light">{{ Article?.Author ?? '' }}</small>
        </span>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12">
        <div class="content-wrapper">
          <p class="article-content" [innerHTML]="Article?.Summary"></p>
          <a class="harmony-secondary-link" (click)="viewArticle();$event.stopPropagation()">Read more</a>
        </div>
      </div>
    </div>
  </div>
</div>
